import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import HeaderPage from "../HeaderPage";
import "./styles.css";
import api from "../../services/api";
import TabelaResultados from "./Tabela/tabela";
import { useNavigate } from "react-router-dom";
import { Spin, Alert, Button } from "antd";

export interface BookingItem {
  _id: string;
  armador: string;
  data_embarque: string;
  embarcador_email: string;
  embarcador_nome: string;
  porto_embarque: string;
  porto_descarga: string;
  mercadoria: string;
  tipo_container: string;
  quantidade_containers: number | string;
  valor: number | string;
  status: string;
  createdAt: string;
  bookingFile?: string;
  blFile?: string;
}

const Bookings = () => {
  const [bookings, setBookings] = useState<BookingItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const routeNewBooking = () => {
    navigate("/bookingAdd");
  };

  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      setError(null);
      try {
        // Novo endpoint!
        const resp = await api.get("/bookingnew/me");
        setBookings(resp.data || []);
      } catch (error: any) {
        setError(error?.response?.data?.error || "Erro ao buscar bookings");
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="bookings" />
      <main>
        <HeaderPage nomeOpcao="Bookings" />
        <div className="main-content">
          <div className="main-content-title">
          
            {loading ? (
              <Spin tip="Carregando bookings..." />
            ) : error ? (
              <Alert type="error" message={error} showIcon />
            ) : (
              <TabelaResultados response={bookings} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Bookings;
